export const getInitialValues = (data: any) => {
  return {
    name: data?.name,
    description: data?.description || null,
    contactEmail: data?.contactEmail || null,
    logo: data?.logo?._id || null
  };
};
